import { ReactNode } from 'react';
import classNames from 'classnames';

import { PropsWithClassname } from '@/app/types';

export interface BadgeProps extends PropsWithClassname {
  icon?: ReactNode;
  text: string;
}

function Badge({ icon, text, className }: BadgeProps) {
  return (
    <div
      className={classNames(
        className,
        'h-[30px] whitespace-nowrap flex items-center bg-success-light text-success-mid text-[12px]  px-[12px] rounded-full uppercase tracking-[1px] font-medium',
      )}
    >
      {!!icon && <div className="shrink-0 mr-[6px]">{icon}</div>}
      {text}
    </div>
  );
}

export default Badge;
